// SdsSearchForm.js
// Single search box with an Advanced disclosure (manufacturer, part number, match mode).

import React from "react";
import { TextInput, Button, OptionSelect } from "../ui";
import styles from "./SdsLookupSection.module.css";

const MATCH_OPTIONS = [
  { value: "contains", label: "Contains" },
  { value: "begins_with", label: "Begins with" },
  { value: "equals", label: "Exact" },
];

export const SdsSearchForm = ({
  criteria,
  onChange,
  onSubmit,
  onClear,
  disabled = false,
  errorMessage,
}) => {
  const advancedOpen = !!criteria.advancedOpen;
  const matchValue =
    MATCH_OPTIONS.find((option) => option.value === criteria.match) ||
    MATCH_OPTIONS[0];

  const handleSubmit = (event) => {
    event.preventDefault();
    if (!disabled) onSubmit();
  };

  return (
    <form className={styles.searchForm} onSubmit={handleSubmit} noValidate>
      <div className={styles.searchRow}>
        <div className={styles.searchField}>
          <TextInput
            label="Product name or CAS number"
            id="sds-search-query"
            value={criteria.query}
            onChange={(event) => onChange({ query: event.target.value })}
            disabled={disabled}
            error={errorMessage}
            placeholder="e.g. WD-40 or 67-64-1"
          />
        </div>
        <div className={styles.searchButtons}>
          <Button variant="form" type="submit" disabled={disabled}>
            Search
          </Button>
          <Button type="button" onClick={onClear} disabled={disabled}>
            Clear
          </Button>
        </div>
      </div>

      <button
        type="button"
        className={styles.linkButton}
        aria-expanded={advancedOpen}
        aria-controls="sds-advanced-fields"
        onClick={() => onChange({ advancedOpen: !advancedOpen })}
      >
        {advancedOpen ? "Hide advanced" : "Advanced"}
      </button>

      {advancedOpen && (
        <div id="sds-advanced-fields" className={styles.advancedRow}>
          <TextInput
            label="Manufacturer"
            id="sds-search-manufacturer"
            value={criteria.manufacturerName}
            onChange={(event) => onChange({ manufacturerName: event.target.value })}
            disabled={disabled}
          />
          <TextInput
            label="Part number"
            id="sds-search-part-number"
            value={criteria.partNumber}
            onChange={(event) => onChange({ partNumber: event.target.value })}
            disabled={disabled}
          />
          <OptionSelect
            label="Match"
            id="sds-search-match"
            options={MATCH_OPTIONS}
            value={matchValue}
            onChange={(option) => onChange({ match: option?.value || "contains" })}
            disabled={disabled}
            isClearable={false}
            isSearchable={false}
          />
        </div>
      )}
    </form>
  );
};
